// Best-effort display names for Kyte fares. `fare.name` doubles as a logic
// key (upsell grouping, seat rules) via `brandedFare`, so we never rewrite
// it — we resolve a display name here for `brandedFareLabel`. Keys are
// `<CARRIER>:<hash>` (name lowercased, whitespace removed) and only a
// complete match applies; any miss (including a carrier renaming a fare)
// falls back to the raw name.

import { as_compare_string } from '@liveflight/utilities/mixins';
import { RYANAIR_CARRIER_CODES } from '@liveflight/resources/carriers';

// Ryanair fare-family → display name (TBD). Same copy for every Ryanair
// carrier code, so we expand it across RYANAIR_CARRIER_CODES below.
const RYANAIR_FARE_DISPLAY_NAMES = {
  sure: 'Plus',
  regu: 'Regular',
};

const build_ryanair_entries = () => {
  const entries = {};
  RYANAIR_CARRIER_CODES.forEach((code) => {
    Object.keys(RYANAIR_FARE_DISPLAY_NAMES).forEach((fare) => {
      entries[`${code}:${fare}`] = RYANAIR_FARE_DISPLAY_NAMES[fare];
    });
  });
  return entries;
};

export const KYTE_FARE_DISPLAY_NAMES = {
  ...build_ryanair_entries(),
};

/**
 * Build the `<CARRIER>:<hash>` lookup key for a fare name.
 * @param {string} carrier marketing carrier code, e.g. "FR"
 * @param {string} name verbatim upstream fare name
 * @returns {string}
 */
export const kyte_fare_name_key = (carrier, name) => {
  const code = String(carrier || '').toUpperCase();
  return `${code}:${as_compare_string(name)}`;
};

/**
 * Resolve the best-effort display name for a Kyte fare: the mapped name on a
 * complete match, otherwise the raw name (empty mappings count as no match).
 * @param {string} carrier marketing carrier code, e.g. "FR"
 * @param {string} name verbatim upstream fare name
 * @returns {string}
 */
export const kyte_fare_display_name = (carrier, name) => {
  const raw = String(name || '');
  return KYTE_FARE_DISPLAY_NAMES[kyte_fare_name_key(carrier, name)] || raw;
};
